//
import { client } from '../../graphql/client';
import { DeleteHairdresserSalons } from '../../graphql/generated-queries/delete-hairdresser-salons-queries';

export async function removeHairdresserSalon(input) {
  try {
    return await client.mutate({ mutation: DeleteHairdresserSalons, variables: { ids: [input.id] } });
  } catch (err) {
    console.error(err);
  }
}
